// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__y6SU_","row":"ProcedureTreatmentSummary_row__1omWF"};